<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link :to="`/dashboard`" :k="'home'" :name="`Главная`" />
        <sidebar-link
          v-for="(route, key) in routes"
          :to="`/${key}`"
          :path="key"
          :k="key"
          :key="key"
          :name="route"
        />
        <sidebar-link :to="`/quit`" :name="`Выход`" :k="'quit'" />
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["routes"]),
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>

<style>
.logout {
  border: none;
  box-shadow: none;
  width: 100%;
  position: absolute;
  bottom: 30px;
  background: transparent;
  color: #fff;
  font-size: 20px;
  text-align: left;
  padding: 10px 25px;
}
</style>
